import { useCallback, useEffect, useState } from "react";
import type * as Y from "yjs";
import {
  type DomainMaps,
  getProjectMeta,
  type ProjectMeta,
  runLocal,
  setProjectMetaField,
} from "@electro-planner/domain";

export type ProjectMetaState = {
  meta: ProjectMeta;
  setField: (key: keyof ProjectMeta, value: string) => void;
};

/**
 * Observerar projectMeta-Y.Map och re-renderar vid ändringar. setField wrappar
 * i LOCAL_ORIGIN så att redigering av title-block-fälten blir en egen undo-step.
 */
export function useProjectMeta(doc: Y.Doc, maps: DomainMaps): ProjectMetaState {
  const [meta, setMeta] = useState<ProjectMeta>(() => getProjectMeta(maps));

  useEffect(() => {
    setMeta(getProjectMeta(maps));
    const handler = () => setMeta(getProjectMeta(maps));
    maps.projectMeta.observe(handler);
    return () => maps.projectMeta.unobserve(handler);
  }, [maps]);

  const setField = useCallback<ProjectMetaState["setField"]>(
    (key, value) => {
      runLocal(doc, () => {
        setProjectMetaField(maps, key, value);
      });
    },
    [doc, maps],
  );

  return { meta, setField };
}
